import GenerateCodeField from './GenerateCodeField'
import withGenerateCodeField from './withGenerateCodeField'

const ConnectedGenerateCodeField = withGenerateCodeField(GenerateCodeField)

export { ConnectedGenerateCodeField as GenerateCodeField }
